import React, { useEffect, useMemo, useState } from 'react'

import { PostsGridView } from 'partials/UpspaceTabs/widgets/PostsGridView'
import { HorizontalTagsLayout } from 'partials/WorkoutTags/subcomponents/HorizontalTagsLayout'

import { Box } from 'widgets/Box'

import { useWorkoutTagsFilter } from 'hooks/useWorkoutTagsFilter'

import { useFocusMode } from 'contexts/FocusModeContext'

import { TagGroup } from 'types/workoutTag'

type TagFilterResultsProps = {
  filters: any
  handleEditFilter: () => void
}

export const WorkoutTagsFilter = ({ filters, handleEditFilter }: TagFilterResultsProps) => {
  const [searchQueryTags, setSearchQueryTags] = useState<TagGroup[] | undefined>()
  const { results, isLoading: isLoadingResults } = useWorkoutTagsFilter(searchQueryTags ?? [])
  const [workoutTypes, setWorkoutTypes] = useState<TagGroup | undefined>(filters.workoutTypes)
  const [muscleGroup, setMuscleGroup] = useState<TagGroup | undefined>(filters.muscleGroup)
  const [durations, setDurations] = useState<TagGroup | undefined>(filters.duration)
  const [locations, setLocations] = useState<TagGroup | undefined>(filters.location)
  const [combinedTagsData, setCombinedTagsData] = useState<TagGroup | undefined>()

  const focusMode = useFocusMode()
  const isFocusMode = useMemo(() => focusMode.group !== undefined, [focusMode.group])

  let finalResults = [...results]
  if (isFocusMode) {
    finalResults = results.filter((res) => res?.program?.id === focusMode.group?.id)
  }

  useEffect(() => {
    setWorkoutTypes(filters.workoutTypes)
    setMuscleGroup(filters.muscleGroup)
    setDurations(filters.duration)
    setLocations(filters.location)
  }, [filters])

  useEffect(() => {
    if (
      !workoutTypes?.tags.length &&
      !muscleGroup?.tags.length &&
      !durations?.tags.length &&
      !locations?.tags.length
    ) {
      setCombinedTagsData(undefined)
      return
    }

    setCombinedTagsData({
      id: '',
      name: 'Filters',
      style: 'badge',
      maxSelection: workoutTypes?.maxSelection,
      tags: [
        ...(workoutTypes?.tags ?? []),
        ...(muscleGroup?.tags ?? []),
        ...(durations?.tags.map((item) => `${item} min`) ?? []),
        ...(locations?.tags ?? []),
      ],
    })

    const filterQuery = buildQueryGroups()
    setSearchQueryTags(filterQuery)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workoutTypes, muscleGroup, durations, locations])

  const buildQueryGroups = (): TagGroup[] => {
    const queryGroups: TagGroup[] = []
    workoutTypes && workoutTypes.tags.length && queryGroups.push(workoutTypes)
    muscleGroup && muscleGroup.tags.length && queryGroups.push(muscleGroup)
    durations && durations.tags.length && queryGroups.push(durations)
    locations && locations.tags.length && queryGroups.push(locations)
    return queryGroups
  }

  if (!combinedTagsData) return null

  return (
    <>
      <Box margin={{ top: 'md', horizontal: 'md' }}>
        <HorizontalTagsLayout
          data={combinedTagsData}
          onSelect={(index) => handleEditFilter()}
          selectedItems={combinedTagsData.tags}
        />
      </Box>
      <Box flex={1}>
        <PostsGridView
          columns={2}
          showCompactItems={false}
          isLoading={isLoadingResults}
          onEndReached={() => {}}
          posts={finalResults ?? []}
        />
      </Box>
    </>
  )
}
